import cn from "classnames";
import { splitKeyFromProps } from "helpers/reactTableProps";
import Sort from "icons/planning/sort.svg";
import SortDown from "icons/planning/sort-down.svg";
import SortUp from "icons/planning/sort-up.svg";
import React, { useState } from "react";

export default function HeaderCell(props) {
    const [opened, setOpened] = useState(false);
    const { column, sorted } = props;
    const { key: headerKey, props: headerProps } = splitKeyFromProps(column.getHeaderProps());

    const sortClickHandle = (column) => column.sortable && openSort();

    const openSort = () => {
        if (opened) {
            closeSort();
        } else {
            setOpened(true);
            setTimeout(() => {
                document.addEventListener("click", closeSort);
            }, 0);
        }
    };

    const closeSort = () => {
        setOpened(false);
        document.removeEventListener("click", closeSort);
    };

    const sortIcon = () => {
        if (!column.sortable) {
            return null;
        }

        if (column.id === sorted.column && sorted.direction === "asc") {
            return <SortUp className="p-table__head-icon" />;
        } else if (column.id === sorted.column && sorted.direction === "desc") {
            return <SortDown className="p-table__head-icon" />;
        } else {
            return <Sort className="p-table__head-icon" />;
        }
    };

    return (
        <div key={headerKey} {...headerProps} className="td">
            <div
                className={cn("p-table__head-title", { "cursor-pointer": column.sortable })}
                onClick={() => sortClickHandle(column)}
            >
                <div
                    className={cn("p-table__head-title--text", {
                        "p-table__head-title---text-with-icon": column.sortable || column.AdditionalIcon,
                    })}
                >
                    {column.render("Header")}
                </div>
                {sortIcon()}
                {column.AdditionalIcon && column.render("AdditionalIcon")}
                {opened && column.render("Sort")}
            </div>
            {column.filterable && <div className="p-table__column-filter">{column.render("Filter")}</div>}
            <div
                {...column.getResizerProps()}
                className={`p-table__resizer ${column.isResizing ? "isResizing" : ""}`}
            />
        </div>
    );
}
